<div id="content" class="extensible">
  <div class="page-title">
    <h1>{{ page_title }}</h1>
  </div>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      @if (is_rrhh_or_admin()) {
        <mat-form-field appearance="outline" class="bisual-paginator-select">
          <mat-label>Responsable</mat-label>
          <mat-select formControlName="responsible_user_id">
            <mat-option [value]="''">Todas</mat-option>
            <mat-option [value]="current_user_id">Las que gestiono yo</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="bisual-paginator-select">
          <mat-label>Estado</mat-label>
          <mat-select formControlName="status">
            <mat-option [value]="''">Todos</mat-option>
            @for (option of status_options; track option.status) {
              <mat-option [value]="option.status">
                {{ option.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-left: auto"
      >
      </mat-paginator>
    </form>

    <div class="bisual-table-container">
      <table mat-table [dataSource]="data_source">
        <ng-container matColumnDef="user_name">
          <th mat-header-cell *matHeaderCellDef>Usuario</th>
          <td mat-cell *matCellDef="let request; dataSource: data_source">{{ request.user_name }}</td>
        </ng-container>

        <ng-container matColumnDef="week">
          <th mat-header-cell *matHeaderCellDef>Semana</th>
          <td mat-cell *matCellDef="let request; dataSource: data_source">{{ request.week_label }}</td>
        </ng-container>

        <ng-container matColumnDef="reason">
          <th mat-header-cell *matHeaderCellDef>Motivo</th>
          <td
            mat-cell
            *matCellDef="let request; dataSource: data_source"
            class="reason-cell"
            [matTooltip]="request.reason"
            [matTooltipDisabled]="request.reason_truncated === request.reason"
          >
            {{ request.reason_truncated }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let request; dataSource: data_source">
            <span class="status-pill" [class]="'status-' + request.status">{{ request.status_label }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let request; dataSource: data_source">
            <div class="actions-cell">
              <button mat-icon-button (click)="openDetail(request); $event.stopPropagation()" matTooltip="Ver detalle">
                <mat-icon>visibility</mat-icon>
              </button>
              <button
                mat-icon-button
                (click)="openApprovalStatusDialog(request); $event.stopPropagation()"
                matTooltip="Estado de aprobación"
              >
                <mat-icon>info</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayed_columns"></tr>
        <tr mat-row class="clickable-row" *matRowDef="let row; columns: displayed_columns" (click)="openDetail(row)"></tr>
      </table>
    </div>
  </div>
</div>
